import { API } from './config-service.api';

export const getRegionsApi = (country: string) => API.get('/cities', { params: { country } });
